import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.detallesFacturacion.detalle', {
    url: '/:folio',
    data: {title: 'Detalle {{Data.Folio || "nuevo"}}'},
    params: {folio: {value: 'nuevo', squash: false}},
    resolve: {
      Catalogos: ($catalogos) => $catalogos.$fetch(),
      Data: (FinanzasDetallesFacturacion, $stateParams) => {
        return $stateParams['folio'] === 'nuevo' ? {
          Folio: null,
          Fecha: new Date(),
          Fecha_Pago: undefined,
          Status: false,
          Nominas: [],
          Facturas: [],
          Comisionistas: [],
        } : FinanzasDetallesFacturacion.$get($stateParams['folio']);
      },
    },
    template,
    controllerAs: '$ctrl',
    controller (Data, $stateParams, FinanzasDetallesFacturacion, Catalogos, $dialog, $notify, $state, $scope) {
      var $ctrl = this;
      $ctrl.saving = false;
      $ctrl.view = Number($stateParams['view']) || 1;
      $ctrl.data = Data;
      $ctrl.folio = Data['Folio'] || null;
      $ctrl.info = {};
      $ctrl.pristine = undefined;
      $ctrl.catalogos = {
        Empleados: {},
        Bancos: Catalogos.Bancos,
        Bancos_Cuentas: Catalogos.Bancos_Cuentas,
        Monedas: Catalogos.Monedas,
        Empresas: Catalogos.Empresas.$select(),
      };

      // Nóminas
      $ctrl.$addPayroll = function () {
        $dialog.show('finanzas.detallesFacturacion.detalle.nominas.nomina', {Empresas: $ctrl.catalogos.Empresas}).then(function (data) {
          if ($ctrl.info.payrolls[data['ID_Nomina']]) {
            alert('Esta nómina ya se ha agregado')
          } else {
            $ctrl.data.Nominas.push(data);
          }
        });
      };

      $ctrl.$removePayroll = function (payroll) {
        $ctrl.data.Nominas.splice($ctrl.data.Nominas.indexOf(payroll), 1);
      };

      // Facturas
      $ctrl.$addInvoice = function (invoice) {
        $dialog.show('finanzas.detallesFacturacion.detalle.facturas.factura', {invoice: invoice || null}).then(function (data) {
          if ($ctrl.info.invoices[data['Factura']]) {
            alert('Esta factura ya se ha agregado');
            $ctrl.$addInvoice(data);
          } else {
            $ctrl.data.Facturas.push(data);
          }
        });
      };

      $ctrl.$editInvoice = function (invoice) {
        $dialog.show('finanzas.detallesFacturacion.detalle.facturas.factura', {invoice: angular.copy(invoice)}).then(function (data) {
          angular.extend(invoice, data);
        });
      };

      $ctrl.$removeInvoice = function (invoice) {
        $ctrl.data.Facturas.splice($ctrl.data.Facturas.indexOf(invoice), 1);
      };

      // Comisionistas
      $ctrl.$addCommission = function () {
        $dialog.show('finanzas.detallesFacturacion.detalle.comisionistas.comisionista', {
          commission: null,
          payrolls: $ctrl.info.payrolls,
          Empresas: $ctrl.catalogos.Empresas,
          Catalogos: Catalogos,
        }).then(function (commission) {
          $ctrl.data.Comisionistas.push(commission);
        });
      };

      $ctrl.$editCommission = function (commission) {
        $dialog.show('finanzas.detallesFacturacion.detalle.comisionistas.comisionista', {
          commission: angular.copy(commission),
          payrolls: $ctrl.info.payrolls,
          Empresas: $ctrl.catalogos.Empresas,
          Catalogos: Catalogos,
        }).then(function (data) {
          angular.extend(commission, data);
        });
      };

      $ctrl.$removeCommission = function (commission) {
        $ctrl.data.Comisionistas.splice($ctrl.data.Comisionistas.indexOf(commission), 1);
      };

      // Guardar información
      $ctrl.set = function () {
        $ctrl.saving = true;
        return FinanzasDetallesFacturacion.$add($ctrl.folio, $ctrl.data).then(function (folio) {
          $state.go($state.current, {folio: folio}, {reload: true});
        }).catch(function (error) {
          $notify.error(error);
          $ctrl.saving = false;
        });
      };

      $ctrl.$cancel = function () {
        if (!$ctrl.folio) {
          $state.go('^.list');
        } else {
          $state.reload();
        }
      };

      // Exportar
      $ctrl.$export = function () {
        FinanzasDetallesFacturacion.$export($ctrl.folio)
      };

      $ctrl.charts = {
        Comisionistas: {},
      };

      // Procesar información
      $scope.$watch('$ctrl.data', function () {
        $ctrl.info.payrolls = {};
        $ctrl.info.invoices = {};
        $ctrl.info.commissions = {};
        $ctrl.info.payrollsTotals = {
          Subtotal: 0,
          Comision_Porcentaje: 0,
          Comision: 0,
          IVA: 0,
          Total: 0,
        };
        $ctrl.info.commissionsTotals = {Comision_Porcentaje: 0, Total: 0};
        $ctrl.info.invoicesTotals = {Subtotal: 0, Comision: 0, IVA: 0, Total: 0};

        $ctrl.data.Nominas.forEach(function (payroll) {
          $ctrl.info.payrolls[payroll['ID_Nomina']] = payroll;
          angular.forEach($ctrl.info.payrollsTotals, function (v, k) {
            $ctrl.info.payrollsTotals[k] += Number(payroll[k]);
          });
        });

        $ctrl.data.Facturas.forEach(function (invoice) {
          $ctrl.info.invoices[invoice['Factura']] = invoice;
          angular.forEach($ctrl.info.invoicesTotals, function (v, k) {
            $ctrl.info.invoicesTotals[k] += Number(invoice[k]);
          });
        });

        $ctrl.charts.Comisionistas = {data: [], labels: []};
        $ctrl.data.Comisionistas.forEach(function (comisionista) {
          $ctrl.charts.Comisionistas.labels.push(comisionista['Empleado']);
          $ctrl.charts.Comisionistas.data.push(comisionista['Total']);
          angular.forEach($ctrl.info.commissionsTotals, function (v, k) {
            $ctrl.info.commissionsTotals[k] += Number(comisionista[k]);
          });
        });

        $ctrl.pristine = $ctrl.pristine == undefined;
        $ctrl.data.Status = $ctrl.folio ? (Math.round($ctrl.info.payrollsTotals.Total) - Math.round($ctrl.info.invoicesTotals.Total) == 0 || parseInt($ctrl.info.payrollsTotals.Total) - parseInt($ctrl.info.invoicesTotals.Total) == 0) : false;
        $ctrl.data.Fecha_Pago = $ctrl.data.Status ? $ctrl.data.Fecha_Pago : undefined;
      }, true);
    },
  });
});



// WEBPACK FOOTER //
// ./src/finanzas/_/detallesFacturacion/detalle/controller.js